import React from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';

const PodcastLibraryButtonAnchor = styled.a`
  height: 48px;
  padding: 12px 16px;
  border-radius: 4px;
  box-shadow: var(--dropshadow, 0 2px 4px 0 #22223340);
  font-size: 16px;
  font-weight: 500;
  background-color: var(--button-primary-fill, #0645b1);
  color: var(--button-primary-text, #ffffff);
  text-decoration: none;

  display: flex;
  align-items: center;

  &:hover {
    background-color: var(--button-primary-fill-hover, #0c3b8d);
    color: var(--button-primary-text, #ffffff) !important;
    text-decoration: none;
  }

  &:active {
    background-color: var(--button-primary-fill-press, #082f75);
    color: var(--button-primary-text, #ffffff) !important;
    text-decoration: none;
  }

  &:visited {
    color: var(--button-primary-text, #ffffff) !important;
    text-decoration: none;
  }
`;

const IconContainer = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

const PodcastLibraryButton = () => {
  return (
    <ImpressionWatcher source="podcast_library_nav_button">
      <PodcastLibraryButtonAnchor href="/podcast_library?trigger=podcast_library_nav">
        <IconContainer>
          <Icon name="books_movies_and_music" size={22} />
        </IconContainer>
        Podcast Library
      </PodcastLibraryButtonAnchor>
    </ImpressionWatcher>
  );
};

export default PodcastLibraryButton;
